import { get } from 'lodash';

export const lockOrientation = get(window, 'screen.orientation.lock', () => { /* VOID */ });
export const unlockOrientation = get(window, 'screen.orientation.unlock', () => { /* VOID */ });

